//@flow
import React, { Component } from 'react';
import { createFragmentContainer, graphql, QueryRenderer } from 'react-relay';
import getter from 'dibs-object-getter';
import { getBuyerId } from 'dibs-cookie-jar';

import Envelope from 'dibs-icons/exports/Envelope';

import styles from './ProfileContactInfo.scss';

import type { Element } from 'react';
import type { RelayProp } from 'react-relay';

import type { ContactDesignerModal_tradeFirm as TradeFirmType } from './__generated__/ContactDesignerModal_tradeFirm.graphql';

type Props = {
    relay?: RelayProp,
    tradeFirm: ?TradeFirmType,
};

type State = {
    isOpen: boolean,
    isLoading: boolean,
    ShareModal: Element,
    buyerId: ?string,
};

class ContactDesignerModalComponent extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isLoading: true,
            isOpen: false,
            ShareModal: null,
            buyerId: null,
        };
    }

    componentDidMount() {
        import(
            /* webpackChunkName: "dibsSendToFriendModal" */
            'dibs-send-to-friend-modal'
        ).then(({ default: ShareModal }: Element) => {
            const buyerId = getBuyerId(document.cookie);

            this.setState({ ShareModal, buyerId });

            const params = new URLSearchParams(document.location.search);
            const modal = params.get('modal');
            if (modal === 'contactFirm') {
                this.setState({ isOpen: true });
            }
        });
    }

    onClickContactButton = () => {
        this.setState({ isOpen: true });
    };

    handleCloseModal = () => {
        this.setState({ isOpen: false });
    };

    handleShareMutationResponse = (response: any) => {
        console.log('repsonse', response);
    };

    render() {
        const { ShareModal } = this.state;
        const buyerId: string = this.state.buyerId || '';
        const hasBuyerId: boolean = !!buyerId;

        return (
            <div className={styles.envelopeWrapper} onClick={this.onClickContactButton}>
                <Envelope className={styles.envelope} />
                {this.props.relay && (
                    <QueryRenderer
                        environment={this.props.relay.environment}
                        variables={{ buyerId, hasBuyerId }}
                        query={graphql`
                            query ContactDesignerModalQuery(
                                $buyerId: String!
                                $hasBuyerId: Boolean!
                            ) {
                                viewer {
                                    user(userId: $buyerId) @include(if: $hasBuyerId) {
                                        profile {
                                            email
                                        }
                                    }
                                }
                            }
                        `}
                        render={({ props }) => {
                            // Share modal has not been async'd in yet
                            if (!ShareModal) {
                                return null;
                            }

                            const buyerEmail = getter(props)
                                .at('viewer')
                                .at('user')
                                .at('profile')
                                .value('email');

                            return (
                                <ShareModal
                                    relay={this.props.relay}
                                    closeModal={this.handleCloseModal}
                                    modalOpen={this.state.isOpen}
                                    senderEmail={buyerEmail || ''}
                                    recipientEmails={[
                                        getter(this.props.tradeFirm)
                                            .at('publicProfile')
                                            .value('email'),
                                    ]}
                                    handleMutationResponse={this.handleShareMutationResponse}
                                    type="DESIGN_PROFILE"
                                />
                            );
                        }}
                    />
                )}
            </div>
        );
    }
}

export const ContactDesignerModal = createFragmentContainer(ContactDesignerModalComponent, {
    tradeFirm: graphql`
        fragment ContactDesignerModal_tradeFirm on TradeFirmType {
            publicProfile {
                email
            }
        }
    `,
});
